import { createSelector } from 'reselect';

const wsSelector = state => state.ws;

const getIsWsFetching = createSelector(
  [wsSelector],
  result => (result ? result.isFetching : undefined),
);

const getSocketOpened = createSelector(
  [wsSelector],
  result => (result && result.socketStatus ? result.socketStatus.toLowerCase() : undefined),
);

const getIsClosedSockets = createSelector(
  [wsSelector],
  result => (result ? result.isClosedSockets : undefined),
);

const getIsOpenedSockets = createSelector(
  [wsSelector],
  result => (result ? result.isOpenedSockets : undefined),
);

const getIsApprovedOrder = createSelector(
  [wsSelector],
  result => (result ? result.isApprovedOrder : undefined),
);
export const getIsWaiting = createSelector(
  [wsSelector],
  result => result.waiting,
);

export default {
  getIsWsFetching,
  getSocketOpened,
  getIsClosedSockets,
  getIsOpenedSockets,
  getIsApprovedOrder,
  getIsWaiting,
};
